import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { BsArrowClockwise, BsChevronLeft } from 'react-icons/bs';
import styled from 'styled-components';

interface ExportHistoryHeaderProps {
  onRefresh: () => void;
  isLoading: boolean;
  totalRecords?: number;
}

const ExportHistoryHeader = ({ onRefresh, isLoading, totalRecords }: ExportHistoryHeaderProps) => {
  const [canGoBack, setCanGoBack] = useState(false);

  useEffect(() => {
    // Check if there's browser history to go back to
    setCanGoBack(window.history.length > 1);
  }, []);

  const handleBackClick = () => {
    window.history.back();
  };

  return (
    <StyledHeader>
      <div className="header-content">
        {canGoBack && (
          <Button variant="link" className="back-button" onClick={handleBackClick}>
            <BsChevronLeft />
            Back
          </Button>
        )}
        <h3>Export History</h3>
        {totalRecords !== undefined && <span className="total-count">{totalRecords} Reports</span>}
      </div>
      <Button
        variant="outline-secondary"
        size="sm"
        onClick={onRefresh}
        disabled={isLoading}
        className="refresh-btn"
      >
        <BsArrowClockwise className={isLoading ? 'spinning' : ''} />
        Refresh
      </Button>
    </StyledHeader>
  );
};

export default ExportHistoryHeader;

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .header-content {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .back-button {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 0;
      margin-bottom: 8px;
      font-size: 14px;
      text-decoration: none;
      color: ${({ theme }) => theme.text};
      opacity: 0.8;
      align-self: flex-start;

      &:hover {
        color: ${({ theme }) => theme.primary_color};
        text-decoration: none;
        opacity: 1;
      }

      svg {
        font-size: 16px;
      }
    }

    h3 {
      margin: 0;
      color: #333;
      font-weight: 600;
      color: ${({ theme }) => theme.text};
    }

    .total-count {
      font-size: 14px;
      color: ${({ theme }) => theme.text};
      opacity: 0.7;
      font-weight: 400;
    }
  }

  .refresh-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    padding: 6px 12px;

    .spinning {
      animation: spin 1s linear infinite;
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
